import React from 'react';
import { Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const CitizenCharterStep = ({ 
  ccAwareness, setCCAwareness,
  ccVisibility, setCCVisibility,
  ccHelpfulness, setCCHelpfulness,
  themeColors 
}) => {
  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 3, fontSize: { xs: '0.875rem', sm: '1rem' } }}>
        INSTRUCTIONS: Select your answer to the Citizen's Charter (CC) question. The Citizen's 
        Charter is an official document that reflects the services of a government agency/office 
        including its requirements, fees, and processing times among others.
      </Typography>
      
      <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
        CC1. Which of the following best describes your awareness of a CC?
      </Typography>
      <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
        <RadioGroup
          value={ccAwareness}
          onChange={(e) => setCCAwareness(e.target.value)}
        >
          {[
            "I know what a CC is and I saw this office's CC.",
            "I know what a CC is but I did not see this office's CC.",
            "I learned of the CC only when I saw this office's CC.",
            "I do not know what a CC is and I did not see one in this office."
          ].map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={
                <Radio 
                  sx={{
                    color: themeColors.borderColor,
                    '&.Mui-checked': {
                      color: themeColors.primary,
                    },
                  }}
                />
              }
              label={option}
              sx={{ 
                border: `1px solid ${themeColors.borderColor}`,
                borderRadius: 1,
                mb: 1,
                p: 1,
                width: '100%',
                '& .MuiFormControlLabel-label': {
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
        CC2. If aware of CC, would you say that the CC of this office was...?
      </Typography>
      <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
        <RadioGroup
          value={ccVisibility}
          onChange={(e) => setCCVisibility(e.target.value)}
          disabled={ccAwareness === "I do not know what a CC is and I did not see one in this office."}
        >
          {[
            "Easy to see",
            "Somewhat easy to see",
            "Difficult to see",
            "Not visible at all",
            "N/A"
          ].map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={
                <Radio 
                  sx={{
                    color: themeColors.borderColor,
                    '&.Mui-checked': {
                      color: themeColors.primary,
                    },
                  }}
                />
              }
              label={option}
              sx={{ 
                border: `1px solid ${themeColors.borderColor}`,
                borderRadius: 1,
                mb: 1,
                p: 1,
                width: '100%',
                '& .MuiFormControlLabel-label': {
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
        CC3. How much did the CC help you in your transaction?
      </Typography>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          value={ccHelpfulness}
          onChange={(e) => setCCHelpfulness(e.target.value)}
          disabled={ccAwareness === "I do not know what a CC is and I did not see one in this office."}
        >
          {[
            "Helped very much",
            "Somewhat helped",
            "Did not help",
            "N/A"
          ].map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={
                <Radio 
                  sx={{
                    color: themeColors.borderColor,
                    '&.Mui-checked': {
                      color: themeColors.primary,
                    },
                  }}
                />
              }
              label={option}
              sx={{ 
                border: `1px solid ${themeColors.borderColor}`,
                borderRadius: 1,
                mb: 1,
                p: 1,
                width: '100%',
                '& .MuiFormControlLabel-label': {
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default CitizenCharterStep;
